
const AnomaliesHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Cost Anomalies
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Anomalies page helps you detect unusual spending patterns and investigate unexpected cost
          spikes across your AWS infrastructure. Proactively identify and resolve cost issues before they
          significantly impact your budget.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Anomaly Detection
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Automatically detect spending patterns that deviate from historical trends.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>ML-Based Detection:</strong> Uses machine learning to identify unusual cost patterns</li>
          <li><strong>Severity Levels:</strong> Anomalies categorized as Critical, High, Medium, or Low</li>
          <li><strong>Threshold Alerts:</strong> Customizable sensitivity for anomaly detection</li>
          <li><strong>Historical Comparison:</strong> Compares current spend to 30, 60, or 90-day averages</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Anomaly Timeline
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          View all detected anomalies in chronological order with key metrics.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Detection Date:</strong> When the anomaly was first identified</li>
          <li><strong>Cost Impact:</strong> Dollar amount of unexpected spending</li>
          <li><strong>Percentage Increase:</strong> How much costs exceeded expected baseline</li>
          <li><strong>Affected Services:</strong> AWS services contributing to the anomaly</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Root Cause Analysis
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Drill down into anomalies to identify the specific causes of cost spikes.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Service Breakdown:</strong> Which AWS services drove the anomaly</li>
          <li><strong>Resource Identification:</strong> Specific resources or instances causing spikes</li>
          <li><strong>Usage Patterns:</strong> Unusual usage that led to increased costs</li>
          <li><strong>Account Attribution:</strong> Which AWS account or environment was affected</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Trend Analysis
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Visualize cost trends to understand patterns and prevent future anomalies.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Daily Cost Trends:</strong> Line charts showing spending over time</li>
          <li><strong>Baseline Comparison:</strong> Expected vs. actual costs visualization</li>
          <li><strong>Anomaly Markers:</strong> Visual indicators on charts where anomalies occurred</li>
          <li><strong>Forecasting:</strong> Predicted costs based on historical patterns</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Anomaly Management
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Take action on detected anomalies and track resolution progress.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Status Tracking:</strong> Mark anomalies as investigating, resolved, or false positive</li>
          <li><strong>Notes & Comments:</strong> Document investigation findings and actions taken</li>
          <li><strong>Notification Rules:</strong> Set up alerts for specific anomaly types or thresholds</li>
          <li><strong>Recurrence Detection:</strong> Identify if similar anomalies have occurred before</li>
        </ul>
      </div>

    </>
  );
};

export default AnomaliesHelp;
